<template>
  <div>
    <h4 class="hide-on-small-only">
      {{ id ? "Editar Usuário" : "Novo Usuário" }}
    </h4>
    <div class="card-panel">
      <form @submit.prevent="save">
        <div class="row">
          <div class="input-field col s12 m10">
            <label for="name">Nome</label>
            <input
              type="text"
              name="name"
              id="name"
              v-model="form.name"
              v-validate="'required|min:3'"
              :class="{ invalid: errors.first('name') }"
            />
            <span class="helper-text" :data-error="errors.first('name')"></span>
          </div>
        </div>

        <div class="row">
          <div class="input-field col s12 m6">
            <label for="email">Email</label>
            <input
              type="text"
              name="email"
              id="email"
              v-model="form.email"
              v-validate="'required|email'"
              :class="{ invalid: errors.first('email') }"
            />
            <span
              class="helper-text"
              :data-error="errors.first('email')"
            ></span>
          </div>
          <div class="col s12 m6">
            <div class="input-field password-input">
              <i
                class="material-icons"
                @click="visibilityPassword = !visibilityPassword"
                >{{ visibilityPassword ? "visibility_off" : "visibility" }}</i
              >
              <label for="password">Senha</label>
              <input
                :type="visibilityPassword ? 'text' : 'password'"
                name="password"
                id="password"
                v-model="form.password"
                v-validate="!id ? 'required' : ''"
                :class="{ invalid: errors.first('password') }"
              />
              <span
                class="helper-text"
                :data-error="errors.first('password')"
              ></span>
            </div>
          </div>
        </div>

        <div class="row" style="margin-bottom: 24px !important;">
          <div class="col s12 m6">
            <select v-model="form.role.uuid">
              <option value disabled selected>Selecione um perfil</option>
              <option
                class="left"
                v-for="role in roles"
                :value="role.uuid"
                :key="role.uuid"
                >{{ role.name }}</option
              >
            </select>
            <span
              class="helper-text"
              v-show="formErros.role"
              style="color: #F44336;"
              >{{ formErros.role }}</span
            >
          </div>
          <div class="col s12 m6">
            <select v-model="form.customer.uuid">
              <option value disabled selected>Selecione um cliente</option>
              <option
                class="left"
                v-for="customer in customers"
                :value="customer.uuid"
                :key="customer.uuid"
                >{{ customer.company_name }}</option
              >
            </select>
          </div>
        </div>

        <div class="actions">
          <router-link
            class="waves-effect btn-large flat form-button"
            stag="a"
            :to="{ name: 'users' }"
            >voltar</router-link
          >
          <div class="spacer"></div>
          <button
            class="waves-effect waves-light btn-large form-button"
            type="submit"
            :class="{ load: load }"
          >
            <feather v-if="load" type="loader" animation="spin" />
            <template v-else>{{ id ? "salvar" : "Cadastrar" }}</template>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "UserCreateOrUpdate",
  data: () => ({
    load: false,
    visibilityPassword: false,
    instanceSelect: {},
    formErros: {
      role: ""
    },
    roles: [],
    customers: [],
    form: {
      name: "",
      email: "",
      password: "",
      role: {
        uuid: ""
      },
      customer: {
        uuid: ""
      }
    }
  }),
  props: {
    id: {
      type: String,
      default: ""
    }
  },
  async mounted() {
    await this.getRoles();
    await this.getCustomers();

    if (this.id) {
      await this.getUser();
      Object.keys(this.form).forEach(val => {
        if (this.form[val]) {
          const el = this.$el.querySelector(`label[for="${val}"]`);
          if (el) el.classList.add("active");
        }
      });
    }

    const el = this.$el.querySelectorAll("select");
    this.instanceSelect = M.FormSelect.init(el);
  },
  beforeDestroy() {
    this.instanceSelect.forEach(element => {
      element.destroy();
    });
  },
  computed: {
    ...mapState("User", ["token"])
  },
  watch: {
    "form.role.uuid"(val) {
      if (val) this.formErros.role = "";
    }
  },
  methods: {
    async getUser() {
      const loader = this.$loading.show({
        loader: "spinner",
        width: 50,
        backgroundColor: "#000",
        color: "#fff"
      });

      try {
        const response = await this.$http.get(`users?search=uuid:${this.id}`);

        const [user] = response.body.data.users;

        const role =
          user.role == null
            ? this.roles.find(val => val.slug == "ADMIN").uuid
            : user.role.uuid;

        this.form.email = user.email;
        this.form.name = user.name;
        this.form.role.uuid = role;

        if (user.customer) this.form.customer.uuid = user.customer.uuid;
      } catch (e) {
        console.error(e);
      }

      loader.hide();
    },
    async save() {
      await this.$validator.validateAll();

      if (!this.form.role.uuid)
        this.formErros.role = "Preenchimento obrigatório";

      if (!this.errors.items.length > 0 && this.form.role.uuid) {
        this.load = true;

        try {
          let msg = "";
          let form = { ...this.form };

          if (!form.customer.uuid) delete form.customer;

          if (!form.password) delete form.password;

          if (!this.id) {
            await this.$http.post(
              "users",
              { user: form },
              {
                headers: {
                  Authorization: `bearer ${this.token}`
                }
              }
            );
            msg = "Cadastro efetuado com sucesso";
          } else {
            await this.$http.post(
              `users/${this.id}`,
              {
                user: form
              },
              {
                headers: {
                  Authorization: `bearer ${this.token}`
                }
              }
            );
            msg = "Usuário alterado com sucesso";
          }

          this.$swal({
            title: "Pronto!",
            text: msg,
            icon: "success",
            button: "Continuar"
          }).then(val => {
            this.$router.push({ name: "users" });
          });
        } catch (e) {
          M.toast({
            html: e.body.message,
            displayLength: 5000
          });
          console.error(e);
        }

        this.load = false;
      }
    },
    async getRoles() {
      try {
        const response = await this.$http.get("roles");
        this.roles = response.body.data.roles;
      } catch (e) {
        console.error(e);
      }
    },
    async getCustomers() {
      const response = await this.$http.get("customers");
      this.customers = response.body.data.customers;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/components/variables";

.row {
  margin-bottom: 0 !important;
}
.actions {
  display: flex;
  justify-content: flex-end;
  .spacer {
    width: 16px;
    height: 24px;
  }

  @media #{$small-and-down} {
    flex-direction: column-reverse;
  }
}
.box-image {
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  img {
    margin-bottom: 16px;
    width: 200px;

    @media #{$small-and-down} {
      width: 100%;
    }
  }
}
.border-error {
  border: 2.4px solid #f44336;
}
</style>
